import * as React from "react";
const SvgFiBrandsUsaa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-usaa_svg__a)">
      <path
        fill="#151A2D"
        d="M21.363 21.625s.689.462 1.36.462c.68 0 1.278-.485 1.278-.485v-2.379s-.603.435-1.269.435c-.671 0-1.369-.467-1.369-.467l-6.934-4.106.634 2.81 6.299 3.725zM2.637 14.298s-.671-.467-1.369-.467c-.697 0-1.268.49-1.268.49v2.37s.571-.422 1.269-.422 1.369.467 1.369.467l5.728 3.39.489-2.144-6.218-3.67zm18.726 4.214s.689.467 1.36.467c.68 0 1.278-.485 1.278-.485v-2.37s-.603.426-1.269.426c-.671 0-1.369-.453-1.369-.453l-7.758-4.6.644 2.81 7.115 4.215zm-18.726-7.31s-.671-.47-1.369-.47c-.697 0-1.268.49-1.268.49v2.37s.571-.427 1.269-.427 1.369.467 1.369.467l6.353 3.761.489-2.148-6.843-4.047zm18.726 4.215s.689.467 1.36.467c.68 0 1.278-.485 1.278-.485v-2.375s-.603.431-1.269.431c-.671 0-1.369-.467-1.369-.467l-8.579-5.076.644 2.81 7.931 4.695zM2.637 8.098s-.671-.467-1.369-.467C.571 7.631 0 8.116 0 8.116v2.366s.571-.426 1.269-.426 1.369.467 1.369.467l6.979 4.133.485-2.144-7.46-4.418zm9.97-.95 8.755 5.165s.689.467 1.36.467c.68 0 1.278-.485 1.278-.485v-2.36s-.603.425-1.269.425c-.671 0-1.369-.462-1.369-.462l-6.77-4.015-.471-1.795c0-.077.068-.113.091-.118l1.151-.363c.154 0 .24.136.24.245l.063.127c.036.023.227-.032.227-.068v-.703a.88.88 0 0 0-.875-.888h-1.147s-.163-.408-.648-.408h-2.175c-.58 0-.716.544-.716.544L8.819 8.642 2.637 4.994s-.671-.467-1.369-.467c-.697 0-1.268.49-1.268.49v2.37s.571-.426 1.269-.426 1.369.467 1.369.467l7.595 4.5 1.736-7.582.634 2.796z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-usaa_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsUsaa;
